import { render } from "./ThumbGallery.vue?vue&type=template&id=6ac8b054&scoped=true"
import script from "./ThumbGallery.vue?vue&type=script&lang=js"
export * from "./ThumbGallery.vue?vue&type=script&lang=js"

import "./ThumbGallery.vue?vue&type=style&index=0&id=6ac8b054&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac8b054"]])

export default __exports__